// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"a02ecd9f","121":"a9a8e6b5","366":"99a58d89","402":"e40fa31d","468":"312cd352","475":"04f420e4","542":"2fc4d9f3","871":"04ebd274","937":"955356e2","971":"31969a34"}[chunkId] + ".chunk.js";
};